import {
  Router,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  NavigationEnd,
  RouterState,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { IRoutePart } from './_interfaces/route-part.interface';

/**
 * A service to parse route parts
 */
@Directive()
@Injectable({
  providedIn: 'root'
})
export class RoutePartsService {
  /** An array of route parts */
  public routeParts: IRoutePart[];

  /** An event emitter that will trigger when a route changes */
  @Output() routeChanged: EventEmitter<IRoutePart[]> = new EventEmitter();

  /**
   * Constructor
   * @param router - A reference to the router
   * @param activatedRoute - A reference to the activated route
   */
  constructor(private router: Router, activatedRoute: ActivatedRoute) {
    const me = this;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const state: RouterState = this.router.routerState;
        const snapshot: RouterStateSnapshot = state.snapshot;
        const root: ActivatedRouteSnapshot = snapshot.root;
        const routeParts = this.generateRouteParts(root);
        me.routeParts = this.formatRouteParts(routeParts);
        this.routeChanged.emit(me.routeParts);
      }
    });
  }

  /**
   * Generate the route parts
   * @param snapshot - The activated route snapshot
   * @returns An array of route parts
   */
  public generateRouteParts(snapshot: ActivatedRouteSnapshot): IRoutePart[] {
    let routeParts = <IRoutePart[]>[];
    if (snapshot) {
      if (snapshot.firstChild) {
        routeParts = routeParts.concat(
          this.generateRouteParts(snapshot.firstChild)
        );
      }
      if (snapshot.url.length) {
        routeParts.push({
          title: snapshot.data['title'],
          breadcrumb: snapshot.data['breadcrumb'],
          url: snapshot.url[0].path,
          urlSegments: snapshot.url,
          params: snapshot.params
        });
      }
    }
    return routeParts;
  }

  /**
   * Format the route parts
   * @param routeParts - An array of route parts
   * @returns An array of formatted route parts
   */
  public formatRouteParts(routeParts: IRoutePart[]): IRoutePart[] {
    // routeParts.push({
    //     title: 'Home',
    //     breadcrumb: 'Home',
    //     url: '/',
    //     urlSegments: [],
    //     params: {},
    // });
    routeParts.reverse();
    let fullUrl = '';
    for (const routePart of routeParts) {
      if (fullUrl === '') {
        fullUrl = routePart.url;
      } else {
        if (fullUrl.endsWith('/') === false) {
          fullUrl += '/';
        }
        fullUrl = fullUrl + routePart.url;
      }
      routePart.url = fullUrl;
    }
    return routeParts;
  }
}
